import { render, staticRenderFns } from "./formbuilderfieldsMention.vue?vue&type=template&id=ec854db6"
import script from "./formbuilderfieldsMention.vue?vue&type=script&lang=js"
export * from "./formbuilderfieldsMention.vue?vue&type=script&lang=js"
import style0 from "./formbuilderfieldsMention.vue?vue&type=style&index=0&id=ec854db6&prod&lang=scss"
import style1 from "./formbuilderfieldsMention.vue?vue&type=style&index=1&id=ec854db6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports